import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/** Az iktatókönyv sorfolytonos nézete, szűrőkkel. */
@Component({
  selector: 'app-ikt-ugyiratok',
  templateUrl: './ugyiratok.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktUgyiratokComponent implements OnInit {
  konyvek: any[] = [];
  sorok: any[] = [];
  hozzaferes: any = null;
  betoltes = false;

  szuro: any = { konyv: '', ev: new Date().getFullYear(), allapot: '', kereses: '', ervenytelen: '' };

  constructor(private ikt: IktatgatoService, private data: DataService, private router: Router) {}

  async ngOnInit() {
    try { this.konyvek = await this.ikt.konyvek(); } catch { /* a lista enélkül is megy */ }
    await this.betolt();
  }

  async betolt() {
    this.betoltes = true;
    try {
      const r = await this.ikt.ugyiratok(this.szuro);
      this.sorok = r.ugyiratok || [];
      this.hozzaferes = r.hozzaferes;
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni az iktatókönyvet.', 'error');
    } finally { this.betoltes = false; }
  }

  nyit(u: any) { this.router.navigateByUrl('/iktatgato/ugyirat/' + u.id); }

  allapotSzin(a: string): string {
    return a === 'folyamatban' ? 'primary'
      : a === 'elintezve' ? 'success'
      : a === 'irattarban' ? 'medium'
      : a === 'selejtezve' ? 'danger' : 'tertiary';
  }

  lejart(u: any): boolean {
    return u.allapot === 'folyamatban' && !!u.hatarido && u.hatarido < new Date().toISOString().slice(0, 10);
  }
}
